// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * XNG-Notes:
 * 1. we reduce -2px from padding top and bottom from original value in Invision because we have border on the button
 */
const buttonSizeVariants = {
    small: {
        height: 28,
        fontSize: 10,
        padding: "5px 24px",
        icon: 10,
        iconPadding: 5,
    },
    medium: {
        height: 35,
        fontSize: 12,
        padding: "8px 24px",
        icon: 12,
        iconPadding: 6,
    },
    large: {
        height: 40,
        fontSize: 14,
        padding: "10px 36px",
        icon: 14,
        iconPadding: 6,
    },
};

export default buttonSizeVariants;
